import axios from "@/api/axiosInstance";
import { FetchEmployeeProfilesResponse } from "./types";

export const fetchEmployeeProfiles =
  async (): Promise<FetchEmployeeProfilesResponse> => {
    const response = await axios.get<FetchEmployeeProfilesResponse>(
      "/api/private/employee-directory/profiles",
    );
    return response.data;
  };
